// extracted by mini-css-extract-plugin
module.exports = {"input":"_1grqcCD4FOUafcnUD7de-b"};